var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutBanner',[_c('nuxt-child')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }